import { createRouter, createWebHistory } from 'vue-router'

import { checkPermission } from '@/utils/helpers/auth.js'

import survey from './routes/survey'
import record from './routes/record'
import takeout from './routes/takeout'
import application from './routes/application'
import weixin from './routes/weixin'
import order from './routes/order'
import housekeeper from './routes/housekeeper'
import group from './routes/group'

import store from './routes/store'
import backBilling from './routes/backBilling'

import setting from './routes/settings'
import ordercenter from './routes/ordercenter'
import finance from './routes/finance'

import user from './routes/user'

// import cardRecord from "./routes/cardRecord";

import shop from './routes/shop'

const routes = [
  {
    path: '/',
    redirect: '/survey',
    name: 'home',
    component: () => import('@/views/home.vue'),
    children: [
      survey,
      record,
      takeout,
      ...store,
      application,
      group,
      weixin,
      order,
      ordercenter,
      housekeeper,
      backBilling,
      setting,
      finance,
      user,
      // cardRecord,
      finance,
      shop
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      name: '登录页'
    }
  },
  {
    path: '/noAuth',
    name: 'noAuth',
    component: () => import('@/views/403.vue'),
    meta: {
      name: '403'
    }
  },
  {
    path: '/weixin/pageManage/create',
    name: 'newPage',
    component: () => import('@/views/weixin/pageManage/create.vue'),
    meta: {
      name: '自定义页面'
    }
  }
]
let router = createRouter({
  history: createWebHistory(),
  routes
})
router.beforeEach((to, form, next) => {
  if (!localStorage.getItem('userInfo') && to.path !== '/login') {
    next({
      path: '/login'
    })
  } else {
    document.title = (to.meta.name ? to.meta.name + '-' : '') + '犀团管理后台'
    // 不知道为何重定向没生效（这里手动处理）
    // nginx可能未配置此参数
    // location / {
    //   try_files $uri $uri/ /index.html;
    // }
    let permission = to?.meta?.permission || []
    if (to.path == '/') {
      next({
        path: '/survey'
      })
    } else {
      if (permission && permission.length) {
        if (checkPermission(permission)) {
          next()
        } else {
          next({
            path: '/noAuth'
          })
        }
      } else {
        next()
      }
    }
  }
})
export default router
